/* ==========================================================================
   TIIAN V2 — Product page scripts
   ========================================================================== */

'use strict';

/* Termékleírás: a h3 címek automatikusan lenyíló szekciókká alakulnak ------- */

document.querySelectorAll('.main-product__description').forEach((rte) => {
  if (!rte.querySelector('h3')) return;

  // Alapból nyitva. A hiányzó attribútum is nyitott fület jelent, hogy a
  // beállítás nélküli (régebben mentett) blokkok se maradjanak csukva.
  const startClosed = rte.hasAttribute('data-accordion-start-closed');

  const chevron =
    '<svg class="icon" viewBox="0 0 24 24" stroke-width="1.2" aria-hidden="true"><path d="M5 9l7 7 7-7"/></svg>';
  const fragment = document.createDocumentFragment();
  let contentWrapper = null;

  Array.from(rte.children).forEach((element) => {
    if (element.tagName === 'H3') {
      const details = document.createElement('details');
      details.className = 'accordion';
      details.open = !startClosed;
      const summary = document.createElement('summary');
      summary.className = 'accordion__summary';
      // A cím marad h3, ahogy a leírásban is az volt — csak a summary
      // tipográfiáját veszi át (`.accordion__heading`).
      const heading = document.createElement('h3');
      heading.className = 'accordion__heading';
      heading.textContent = element.textContent;
      summary.appendChild(heading);
      summary.insertAdjacentHTML('beforeend', chevron);
      contentWrapper = document.createElement('div');
      contentWrapper.className = 'accordion__content rte';
      details.append(summary, contentWrapper);
      fragment.appendChild(details);
    } else if (contentWrapper) {
      contentWrapper.appendChild(element);
    } else {
      fragment.appendChild(element);
    }
  });

  rte.innerHTML = '';
  rte.appendChild(fragment);
});

/* <media-gallery> — thumbnail switching ------------------------------------ */

if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('.main-product__thumbnail');
        if (!thumb) return;
        this.setActiveMedia(thumb.dataset.mediaId);
      });
    }

    setActiveMedia(mediaId) {
      this.querySelectorAll('.main-product__media-item').forEach((item) => {
        item.classList.toggle('is-active', item.dataset.mediaId === mediaId);
      });
      this.querySelectorAll('.main-product__thumbnail').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }
  }
  customElements.define('media-gallery', MediaGallery);
}

/* <variant-selects> — variant picking --------------------------------------- */

if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      const dataScript = this.querySelector('script[type="application/json"]');
      this.variants = dataScript ? JSON.parse(dataScript.textContent) : [];
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    get selectedOptions() {
      return Array.from(this.querySelectorAll('fieldset')).map(
        (fieldset) => fieldset.querySelector('input:checked')?.value
      );
    }

    onVariantChange() {
      const options = this.selectedOptions;
      const variant = this.variants.find((v) =>
        v.options.every((value, index) => value === options[index])
      );
      this.updateVariant(variant);
    }

    updateVariant(variant) {
      const section = this.dataset.section;
      const productForm = document.querySelector(`.product-form[data-section="${section}"]`);
      const idInput = productForm?.querySelector('[data-variant-id]');
      const submitButton = productForm?.querySelector('[name="add"]');
      const label = submitButton?.querySelector('.button__label') || submitButton;

      if (!variant) {
        if (submitButton) {
          submitButton.setAttribute('disabled', 'disabled');
          if (label) label.textContent = window.themeStrings.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      // Update URL so the selected variant is shareable
      if (this.dataset.url) {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${variant.id}`);
      }

      // Availability & button state. A coming-soon és a hide-price termékek
      // gombja letiltva marad — utóbbinál különben 0 Ft-ért kosárba tehető lenne.
      const lockedButton =
        submitButton &&
        (submitButton.classList.contains('is-coming-soon') ||
          submitButton.classList.contains('is-price-hidden'));
      if (submitButton && !lockedButton) {
        if (variant.available) {
          submitButton.removeAttribute('disabled');
          if (label) label.textContent = window.themeStrings.addToCart;
        } else {
          submitButton.setAttribute('disabled', 'disabled');
          if (label) label.textContent = window.themeStrings.soldOut;
        }
      }

      // Update price via section rendering for correct money formatting
      this.renderPrice(variant);

      // Switch media if variant has a featured image
      if (variant.featured_media) {
        const gallery = document.querySelector('media-gallery');
        if (gallery) gallery.setActiveMedia(String(variant.featured_media.id));
      }
    }

    async renderPrice(variant) {
      const section = this.dataset.section;
      const priceWrapper = document.getElementById(`price-${section}`);
      if (!priceWrapper || !this.dataset.url) return;
      try {
        const response = await fetch(
          `${this.dataset.url}?variant=${variant.id}&section_id=${section}`
        );
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const newPrice = parsed.getElementById(`price-${section}`);
        if (newPrice) priceWrapper.innerHTML = newPrice.innerHTML;
      } catch (error) {
        console.error('Price refresh failed', error);
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);
}

/* <product-recommendations> ------------------------------------------------- */

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(this);
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const inner = parsed.querySelector('product-recommendations');
        if (inner && inner.innerHTML.trim().length) {
          this.innerHTML = inner.innerHTML;
        } else {
          const section = this.closest('.related-products');
          if (section) section.style.display = 'none';
        }
      } catch (error) {
        console.error('Recommendations failed', error);
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
}

/* <mobile-purchase-bar> — ragadós vásárlósáv mobilon ----------------------- */
/* Nem másolja a terméket, hanem az eredeti kosárba gombot tükrözi: ugyanazt a
   feliratot, letiltott és betöltő állapotot mutatja, és kattintásra az eredeti
   űrlapot küldi be. Így a variánsváltás és a hibakezelés egy helyen marad. */
if (!customElements.get('mobile-purchase-bar')) {
  class MobilePurchaseBar extends HTMLElement {
    connectedCallback() {
      const root = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      this.original = root && root.querySelector('product-form [name="add"]');
      this.price = root && root.querySelector(`[id="price-${this.dataset.sectionId}"]`);
      if (!this.original) return;

      this.button = this.querySelector('[data-mobile-add]');
      this.mobilePrice = this.querySelector('[data-mobile-price]');
      this.media = matchMedia('(max-width: 749px)');

      this.sync = () => {
        const busy = this.original.getAttribute('aria-busy') === 'true';
        this.button.disabled = this.original.disabled || busy;
        this.button.textContent = this.original.textContent.trim();
        this.button.setAttribute('aria-busy', String(busy));

        const price = this.price && this.price.querySelector('.price');
        if (price) this.mobilePrice.innerHTML = price.outerHTML;

        // Csak akkor látszik, ha mobil nézet van ÉS az eredeti gomb kigörgött.
        this.hidden = !this.media.matches || this.original.getBoundingClientRect().bottom >= 0;
      };

      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.original, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
      if (this.price) {
        this.observer.observe(this.price, { childList: true, subtree: true, characterData: true });
      }

      this.intersection = new IntersectionObserver(this.sync);
      this.intersection.observe(this.original);
      this.media.addEventListener('change', this.sync);

      this.onClick = () => {
        if (this.original.disabled || this.original.getAttribute('aria-busy') === 'true') return;
        const form = this.original.closest('form');
        if (form) form.requestSubmit(this.original);
      };
      this.button.addEventListener('click', this.onClick);

      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.intersection) this.intersection.disconnect();
      if (this.media && this.sync) this.media.removeEventListener('change', this.sync);
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
    }
  }
  customElements.define('mobile-purchase-bar', MobilePurchaseBar);
}
